<div class="complaint-review-container">
  <div class="container-body pb-3 pt-3">
    <form [formGroup]="complaintForm" class="responsive-form">
          <!-- complainant info end-->
          <div class="license-wrapper border-box mb-3">
            <div class="license-header d-flex justify-content-between align-items-center"
              (click)="Complainants = !Complainants" [ngClass]="{'expanded': Complainants, 'collapsed': !Complainants}">
              <h5 class=" mb-0">Complainant Information</h5>
              <button type="button" class="toggle-btn" aria-label="Toggle" [attr.aria-expanded]="!Complainants"
                (click)="$event.stopPropagation(); Complainants = !Complainants">
                <span class="toggle-icon">
                  <i class="fas fa-chevron-up" *ngIf="Complainants" aria-hidden="true"></i>
                  <i class="fas fa-chevron-down" *ngIf="!Complainants" aria-hidden="true"></i>
                </span>
              </button>
            </div>
            <div *ngIf="Complainants" class="section-body p-3 border-box-section">
              <div>
                <p>Please enter the name of the individual submitting this complaint. Only one complainant may be
                  listed.
                  If multiple people are involved, each person must submit their own separate complaint or be listed
                  by the complainant as a witness if they have asked one person to submit on behalf of all parties.
                </p>
              </div>
              <div >
                <div class="d-flex mb-3 flex-wrap responsive-row">
                  <div class="col-12 col-md-6 col-lg-3 pl-1 d-flex flex-column responsive-col">
                    <div class="form-label">Complainant First Name</div>
                    <input class="form-control" [placeholder]="placeholderMessage['P0001']" type="text" tabindex="0"
                      id="input_raiseacomplaint_complainant_first_name" formControlName="complainantFirstName" maxlength="30"
                      minlength="2"  aria-label="Enter Complainant First Name"
                      [attr.aria-invalid]="complaintForm.get('complainantFirstName')?.touched && complaintForm.get('complainantFirstName')?.invalid ? 'true' : null"
                      [attr.aria-describedby]="complaintForm.get('complainantFirstName')?.touched && complaintForm.get('complainantFirstName')?.invalid ? 'complainantFirstName-error' : null"
                      (input)="onComplainantFirstNameInput($event)" (blur)="checkForTrailingSpace($event, 'complainantFirstName')"
                      (keydown.enter)="$event.preventDefault()"
                      [ngClass]="{'is-invalid-error': complaintForm.get('complainantFirstName')?.touched && complaintForm.get('complainantFirstName')?.invalid}" />
                    <div *ngIf="complaintForm.get('complainantFirstName')?.touched && complaintForm.get('complainantFirstName')?.errors as errors">
                      <div id="div_raiseacomplaint_complainant_first_name_error_pattern"
                        *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                        class="text-danger mt-1 err-font">
                        {{ errorMessage['M0157'] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 pl-1 d-flex flex-column responsive-col">
                    <div class="form-label">Complainant Last Name</div>
                    <input class="form-control" [placeholder]="placeholderMessage['P0003']" type="text" tabindex="0"
                      id="input_raiseacomplaint_complainant_last_name" formControlName="complainantLastName" maxlength="30"
                      minlength="2" aria-label="Enter Complainant Last Name"
                      [attr.aria-invalid]="complaintForm.get('complainantLastName')?.touched && complaintForm.get('complainantLastName')?.invalid ? 'true' : null"
                      [attr.aria-describedby]="complaintForm.get('complainantLastName')?.touched && complaintForm.get('complainantLastName')?.invalid ? 'complainantLastName-error' : null"
                       (blur)="checkForTrailingSpace($event, 'complainantLastName')"
                      (keydown.enter)="$event.preventDefault()"
                      [ngClass]="{'is-invalid-error': complaintForm.get('complainantLastName')?.touched && complaintForm.get('complainantLastName')?.invalid}" />
                    <div *ngIf="complaintForm.get('complainantLastName')?.touched && complaintForm.get('complainantLastName')?.errors as errors">
                      <div id="div_raiseacomplaint_complainant_last_name_error_pattern"
                        *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                        class="text-danger mt-1 err-font">
                        {{ errorMessage['M0157'] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 pl-1 d-flex flex-column responsive-col">
                    <div class="form-label" id="label_raiseacomplaint_complainant_email">Complainant Email Address</div>
                    <input class="form-control " [placeholder]="placeholderMessage['P0126']"
                      formControlName="complainantEmail" id="input_raiseacomplaint_complainant_email"
                      [ngClass]="{'is-invalid-error': complaintForm.get('complainantEmail')?.touched && complaintForm.get('complainantEmail')?.invalid}"/>
                    <div *ngIf="complaintForm.get('complainantEmail')?.touched && complaintForm.get('complainantEmail')?.errors as errors">
                      <div id="recoveryEmail-error" *ngIf="!errors['required'] && errors['pattern']"
                        class="text-danger mt-1 err-font">
                        {{ errorMessage['M0015'] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 pl-1 d-flex flex-column responsive-col">
                    <div class="form-label">Complainant Phone Number</div>
                    <input class="form-control " [placeholder]="placeholderMessage['P0102']" type="text"
                      id="input_raiseacomplaint_complainant_phone_number" formControlName="complainantPhoneNumber"
                      [attr.aria-invalid]="(complaintForm.get('complainantPhoneNumber')?.touched && complaintForm.get('complainantPhoneNumber')?.invalid) || phoneExists ? 'true' : null"
                      [attr.aria-describedby]="(complaintForm.get('complainantPhoneNumber')?.touched && complaintForm.get('complainantPhoneNumber')?.invalid) || phoneExists ? 'complainantPhoneNumber-error' : null"
                      tabindex="0" (input)="formatPhoneNumber($event)" (focus)="isPhoneFocused = true"
                      (blur)="isPhoneFocused = false; checkPhone()" (keydown.enter)="$event.preventDefault()"
                      numbersOnly [ngClass]="{
                                      'is-invalid-error':
                                        (complaintForm.get('complainantPhoneNumber')?.touched && complaintForm.get('complainantPhoneNumber')?.invalid) || (phoneExists && !isPhoneFocused)
                                    }" />
                    <div
                      *ngIf="complaintForm.get('complainantPhoneNumber')?.touched && complaintForm.get('complainantPhoneNumber')?.errors as errors">
                      <div id="div_raiseacomplaint_complainant_phone_number_error_pattern"
                        *ngIf="errors['pattern']" class="text-danger mt-1 err-font">
                        {{ errorMessage['M0017'] }}
                      </div>
                    </div>
                    <div id="div_raiseacomplaint_complainant_phone_number_error_exists" *ngIf="phoneExists"
                      class="text-danger mt-1 err-font">
                      The phone number entered is already on file.
                    </div>
                  </div>
                </div>
                <hr class="horizontal-line" />
                <div class="d-flex mb-3 flex-wrap responsive-row">
                  <div class="col-12 col-md-6 col-lg-3 d-flex flex-column pl-1 responsive-col">
                    <div class="form-label">Complainant Street Address</div>
                    <input class="form-control " [placeholder]="placeholderMessage['P0011']" type="text"
                      id="input_raiseacomplaint_complainant_street_address" formControlName="complainantStreetAddress"
                      tabindex="0" class="Inputs form-control text-capitalize" minlength="3" maxlength="60"
                      (input)="onStreetAddressInput($event)" (blur)="onFieldBlur($event, 'complainantStreetAddress')"
                      (keydown.enter)="$event.preventDefault()"
                      [ngClass]="{'is-invalid-error': complaintForm.get('complainantStreetAddress')?.touched && complaintForm.get('complainantStreetAddress')?.invalid}" />
                    <div
                      *ngIf="complaintForm.get('complainantStreetAddress')?.touched && complaintForm.get('complainantStreetAddress')?.errors as errors">
                      <!-- <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0018'] }}
                      </div> -->
                      <div role="alert" *ngIf="errors['specialCharAtEnd']" class="text-danger mt-1 err-font">
                        {{ errorMessage['M0052'] }}
                      </div>
                      <div
                        *ngIf="!errors['required'] && !errors['specialCharAtEnd'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                        class="text-danger mt-1 err-font">
                        {{ errorMessage['M0052'] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 d-flex flex-column pl-1 responsive-col">
                    <div class="form-label">City</div>
                    <input class="form-control " [placeholder]="placeholderMessage['P0013']"
                      formControlName="complainantCity" type="text" id="input_raiseacomplaint_complainant_city"
                      tabindex="0"  aria-label="Complainant City" (keydown.enter)="$event.preventDefault()"
                      [ngClass]="{'is-invalid-error': complaintForm.get('complainantCity')?.touched && complaintForm.get('complainantCity')?.invalid}"
                      minlength="2" maxlength="60" />
                    <div
                      *ngIf="complaintForm.get('complainantCity')?.invalid && complaintForm.get('complainantCity')?.touched && complaintForm.get('complainantCity')?.errors as errors">
                      <!-- <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0019'] }}
                      </div> -->
                      <div role="alert" *ngIf="errors['specialCharAtEnd']" class="text-danger mt-1 err-font">
                        {{ errorMessage['M0050'] }}
                      </div>
                      <div
                        *ngIf="!errors['required'] && !errors['specialCharAtEnd'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                        class="text-danger mt-1 err-font">
                        {{ errorMessage['M0050'] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 d-flex flex-column pl-1 responsive-col">
                    <div class="form-label">State</div>
                    <div class="dropdown-clear-wrapper">
                      <p-dropdown #stateSelected id="select_raiseacomplaint_complainant_state"
                        formControlName="complainantState" [options]="stateList"
                        styleClass="custom-dropdown-border form-control" placeholder="Select State" 
                        tabindex="0"   
                        [attr.aria-invalid]="complaintForm.get('complainantState')?.touched && complaintForm.get('complainantState')?.invalid ? 'true' : null"
                        [attr.aria-describedby]="complaintForm.get('complainantState')?.touched && complaintForm.get('complainantState')?.invalid ? 'complainantState-error' : null"
                        (keydown.enter)="$event.preventDefault()" [ngClass]="{
                                        'is-invalid-errorr': complaintForm.get('complainantState')?.touched && complaintForm.get('complainantState')?.invalid,
                                        'placeholder-color': complaintForm.get('complainantState')?.value === null,
                                        'selected-color': complaintForm.get('complainantState')?.value !== null,
                                        'disable-color': viewOnly
                                      }" />
                      <!-- <button *ngIf="complaintForm.get('complainantState')?.value" type="button"
                        id="btn_complaintForm_clear_state" class="clear-icon" tabindex="-1" [disabled]="viewOnly"
                        (click)="clearState(stateSelected,true); $event.stopPropagation()" aria-label="Clear selection">
                        &#10006;
                      </button> -->
                    </div>
                    <!-- <div
                      *ngIf="complaintForm.get('complainantState')?.invalid && (complaintForm.get('complainantState')?.touched || complaintForm.get('complainantState')?.dirty)"
                      class="text-danger mt-1 err-font">{{ errorMessage['M0020'] }}</div> -->
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 d-flex flex-column pl-1 responsive-col">
                    <div class="form-label">ZIP Code</div>
                    <input class="form-control " [placeholder]="placeholderMessage['P0016']"
                      formControlName="complainantZip" type="text" tabindex="0"
                      id="input_raiseacomplaint_complainant_zip"
                      (input)="zipCodeFormat($event, 'complainantZip')" minlength="5" maxlength="10" 
                      (keydown.enter)="$event.preventDefault()" [ngClass]="{
                                      'is-invalid-error': complaintForm.get('complainantZip')?.touched && complaintForm.get('complainantZip')?.invalid
                                    }" />
                    <div
                      *ngIf="complaintForm.get('complainantZip')?.touched && complaintForm.get('complainantZip')?.errors as errors">
                      <!-- <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0022'] }}
                      </div> -->
                      <div *ngIf="errors['allZeros'] || errors['M0023']" class="text-danger mt-1 err-font">{{
                        errorMessage['M0023'] }}
                      </div>
                      <div *ngIf="errors['invalidZipLength']" class="text-danger mt-1 err-font">
                        Zip code must be either 5 digits or 9 digits.
                      </div>
                      <div
                        *ngIf="!errors['required'] && !errors['allZeros'] && !errors['invalidZipLength'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                        class="text-danger mt-1 err-font">
                        {{ errorMessage['M0023'] }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- complainant info start-->
          <!-- complaint details start -->
          <div class="license-wrapper border-box">
            <div class="license-header d-flex justify-content-between align-items-center" (click)="details = !details"
              [ngClass]="{'expanded': details, 'collapsed': !details}">
              <h5 class=" mb-0">Complaint Details</h5>
              <button type="button" class="toggle-btn" aria-label="Toggle" [attr.aria-expanded]="!details"
                (click)="$event.stopPropagation(); details = !details" >
                <span class="toggle-icon">
                  <i class="fas fa-chevron-up" *ngIf="details" aria-hidden="true"></i>
                  <i class="fas fa-chevron-down" *ngIf="!details" aria-hidden="true"></i>
                </span>
              </button>
            </div>
            <div *ngIf="details" class="section-body p-3 border-box-section">
              <div>
                <p>Please provide the details of your complaint. Include the educator’s name, the date(s), time(s),
                  and a clear description of the alleged violation or concern. Provide as much information as you can
                  to help the Department understand and investigate the issue.</p>
              </div>
              <div class="mb-4">
                <div class="row mb-3 mr-2 responsive-row">
                  <div class="col-12 col-md-6 col-lg-3 pl-1 pr-0 d-flex flex-column responsive-col">
                    <div class="form-label ">Date of Incident</div>
                    <div class="input-group">
                      <input class="form-control" [placeholder]="placeholderMessage['P0104']" #dateTextInput
                        data-placeholder="MM/DD/YYYY" type="text" id="dateOfComplaint" formControlName="dateOfComplaint"
                        [attr.aria-invalid]="complaintForm.get('dateOfComplaint')?.touched && complaintForm.get('dateOfComplaint')?.invalid ? 'true' : null"
                        [attr.aria-describedby]="complaintForm.get('dateOfComplaint')?.touched && complaintForm.get('dateOfComplaint')?.invalid ? 'dateOfComplaint-error' : null"
                        tabindex="0" maxlength="10" appDateMask (dateMaskError)="dateMaskError = $event" 
                        (keydown.enter)="$event.preventDefault()" [ngClass]="{
                    'is-invalid-error': complaintForm.get('dateOfComplaint')?.touched && complaintForm.get('dateOfComplaint')?.invalid,
                    'has-value': !!complaintForm.get('dateOfComplaint')?.value
                  }" />
                      <div class="input-group-append relative">
                        <span class="calendar-input-icon"
                              (click)="!viewOnly && startHiddenDateInput.click()"
                              [style.pointer-events]="viewOnly ? 'none' : 'auto'"
                              [style.opacity]="viewOnly ? '0.5' : '1'"
                              [attr.aria-disabled]="viewOnly">
                          <i class="fa fa-calendar"></i>
                          <input type="date" #startHiddenDateInput (change)="onStartDateChange($event,dateTextInput)"
                            class="calendar-icon" tabindex="-1" [attr.max]="todayString" [disabled]="viewOnly"/>

                        </span>
                      </div>
                    </div>
                    <div
                      *ngIf="complaintForm.get('dateOfComplaint')?.touched && complaintForm.get('dateOfComplaint')?.errors as errors">
                      <div id="dob-error" *ngIf="errors['pattern'] || errors['futureDate']" class="text-danger mt-1 err-font">
                        {{ errorMessage['M0156']}}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 pr-0 d-flex flex-column responsive-col" *ngIf="complaintSource == 'External'">
                    <div class="form-label">Educator Name</div>
                    <input class="form-control " [placeholder]="placeholderMessage['P0105']"
                      formControlName="educatorsFirstName" type="text" tabindex="0" id="educatorsFirstName"
                      formControlName="educatorsFirstName" maxlength="30" minlength="2" 
                      aria-label="Enter educators First Name"
                      [attr.aria-invalid]="complaintForm.get('educatorsFirstName')?.touched && complaintForm.get('educatorsFirstName')?.invalid ? 'true' : null"
                      [attr.aria-describedby]="complaintForm.get('educatorsFirstName')?.touched && complaintForm.get('educatorsFirstName')?.invalid ? 'educatorsFirstName-error' : null"
                      (input)="educatorsFirstName($event)" (blur)="checkForTrailingSpace($event, 'educatorsFirstName')"
                      (keydown.enter)="$event.preventDefault()"
                      [ngClass]="{'is-invalid-error': complaintForm.get('educatorsFirstName')?.touched && complaintForm.get('educatorsFirstName')?.invalid}" />
                    <div *ngIf="complaintForm.get('educatorsFirstName')?.touched && complaintForm.get('educatorsFirstName')?.errors as errors">
                      <div id="educatorsFirstName-error"
                        *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                        class="text-danger mt-1 err-font">
                        {{ errorMessage['M0157'] }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-3">
                  <p>Brief Description of the Alleged Misconduct<span class="text-red">*</span>
                  </p>
                </div>
                <div class=" mb-3 gap_education">
                  <div class="card mt-3" (focusin)="onComplaintEditorInteraction($event)"
                    (click)="onComplaintEditorInteraction($event)">
                    <p-editor #complaintEditor *ngIf="placeholderMessage['P0106']" 
                      [placeholder]="viewOnly ? '' : placeholderMessage['P0106']"
                      formControlName="complaintTextData" [readonly]="viewOnly"
                      appWordCountLimit="10" [style]="{'height':'8rem'}"
                      (onTextChange)="onComplaintEditorInteraction($event)"
                      (onBlur)="onComplaintEditorInteraction($event)">
                    </p-editor>
                  </div>
                  <p-message *ngIf="complaintForm.get('complaintTextData')?.invalid && (complaintForm.get('complaintTextData')?.touched || 
                    complaintForm.get('complaintTextData')?.dirty)" class="text-danger small" severity="error"
                    size="small" variant="simple">Description is required.</p-message>
                </div>
              </div>
               <hr class="horizontal-line" />
              <div class="row header-row justify-content-between align-items-center mt-3 mb-3">
                <div class="w-padding">
                  <span class="title" id="dashboard_title">Licensed Educator Details</span>
                </div>
                <div class="col-auto">
                  <div class="actions d-flex">
                    <div class="export-actions">
                    </div>
                    <div class="column-chooser-actions mr-3 d-flex justify-content-end">
                      <button mat-icon-button class="icon-btn" matTooltip="Column Chooser" matTooltipPosition="above"
                        matTooltipClass="custom-tooltip"
                        (click)="showLicenseEducatorColumnChooser = !showLicenseEducatorColumnChooser"
                        id="dashboard_column_chooser_btn">
                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none">
                          <path
                            d="M4.30775 18H8.3365V6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18ZM9.8365 18H14.1635V6H9.8365V18ZM15.6635 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V6.30775C20 6.21792 19.9712 6.14417 19.9135 6.0865C19.8558 6.02883 19.7821 6 19.6923 6H15.6635V18ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775Z"
                            fill="currentColor" />
                        </svg>
                      </button>
                      <div *ngIf="showLicenseEducatorColumnChooser" class="column-chooser-dialog"
                        id="dashboard_column_chooser_dialog">
                        <div class="column-chooser-header">
                          Column Chooser
                          <button class="column-chooser-close" (click)="closeLicenseEducatorColumnChooser()"
                            id="dashboard_column_chooser_close" >&times;</button>
                        </div>
                        <div class="column-chooser-list">
                          <label *ngFor="let col of licenseEducatorColumns; let i = index" class="column-chooser-checkbox"
                            [id]="'dashboard_column_' + col.dataField">
                            <input type="checkbox"
                              (change)="onLicenseEducatorColumnVisibilityChange(col.dataField, $event.target.checked, col, i)"
                              [checked]="visibleLicenseEducatorColumns[col.dataField]" />
                            {{ col.label }}
                          </label>
                        </div>
                      </div>
                    </div>
                   <button type="button" class="btn btn-primary grid rounded btn-add height_btn"
                     (click)="showLicenseEducatorModal(addLicenseEducator)"
                      aria-label="Add" tooltipPosition="bottom" [disabled]="viewOnly">
                     <i class="pi pi-plus-circle"></i> Add</button>
                  </div>
                </div>
              </div>
              <app-data-grid id="licenseEducatorGrid" [config]="licenseEducatorDataGridConfig"
              [onEducatorNameClick]="onEducatorNameClick"
             [actionsTemplateRef]="licenseEducatorActionsTemplate" [activeTab]="'background'">
                <ng-template #licenseEducatorActionsTemplate let-row let-index="index">
                  <div class="action-buttons-container d-flex gap_action"
                    [id]="'dashboard_div_actions_' + row.index">
                    <div class="action-inline ml-4">
                      <div class="action-flex">
                        <!-- Delete button only for draft applications -->
                        <button mat-icon-button class="action-icon-button ml-2" matTooltip="Delete"
                          matTooltipPosition="above" matTooltipClass="custom-tooltip"
                          (click)="deleteLicenseEducatorRow(getLicenseEducatorRowIndex(row))"
                          [id]="'license_educator_delete_row_' + row.index" [disabled]="viewOnly">
                          <img src="../../assets/images/neveda-images/delete-icon.svg" alt="Delete" width="24"
                            height="24" class="filter-icon">
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </app-data-grid>
            </div>
          </div>
          <!-- complaint details end-->
          <!-- Witness info start-->
          <div class="license-wrapper border-box mb-3">
            <div class="license-header d-flex justify-content-between align-items-center"
              (click)="Witnesses = !Witnesses" [ngClass]="{'expanded': Witnesses, 'collapsed': !Witnesses}">
              <h5 class=" mb-0">Witnesses and Supporting Documentation</h5>
              <button type="button" class="toggle-btn" aria-label="Toggle" [attr.aria-expanded]="!Witnesses"
                (click)="$event.stopPropagation(); Witnesses = !Witnesses" >
                <span class="toggle-icon">
                  <i class="fas fa-chevron-up" *ngIf="Witnesses" aria-hidden="true"></i>
                  <i class="fas fa-chevron-down" *ngIf="!Witnesses" aria-hidden="true"></i>
                </span>
              </button>
            </div>
            <div *ngIf="Witnesses" class="section-body p-3 border-box-section">
              <div>
                <p>List any witnesses or other individuals who have knowledge of the events described in your
                  complaint. Include their contact information and a brief statement if available. You may also upload
                  any documents, photos, or other evidence that supports your complaint.</p>
              </div>
              <form [formGroup]="witnessesForm">
                <div class="mb-4">
                  <div class="row mb-3 mr-2  witness-row-responsive">
                    <div class="col-12 col-md-6 col-lg pl-1 pr-0 d-flex flex-column witness-col-responsive">
                      <div class="form-label">Witness Name<span class="text-red">*</span></div>
                      <input class="form-control " [placeholder]="placeholderMessage['P0107']"
                        formControlName="witnessesName" type="text" tabindex="0" id="witnessesName" maxlength="30"
                        minlength="2" required aria-label="Enter Witness Name" aria-required="true"
                        [attr.aria-invalid]="witnessesForm.get('witnessesName')?.touched && witnessesForm.get('witnessesName')?.invalid ? 'true' : null"
                        [attr.aria-describedby]="witnessesForm.get('witnessesName')?.touched && witnessesForm.get('witnessesName')?.invalid ? 'witnessesName-error' : null"
                        (input)="witnessesName($event, 'main')" (blur)="checkForTrailingSpace($event, 'witnessesName')"
                        [ngClass]="{'is-invalid-error': witnessesForm.get('witnessesName')?.touched && witnessesForm.get('witnessesName')?.invalid}" />
                      <div
                        *ngIf="witnessesForm.get('witnessesName')?.invalid && (witnessesForm.get('witnessesName')?.touched || witnessesForm.get('witnessesName')?.dirty)"
                        class="text-danger small">
                        <div *ngIf="witnessesForm.get('witnessesName')?.errors?.required"
                          class="text-danger mt-1 err-font">{{ errorMessage['M0140'] }}</div>
                        <div
                          *ngIf="!witnessesForm.get('witnessesName')?.errors?.required && (witnessesForm.get('witnessesName')?.errors?.pattern || witnessesForm.get('witnessesName')?.errors?.minlength || witnessesForm.get('witnessesName')?.errors?.maxlength)"
                          class="text-danger mt-1 err-font">{{ errorMessage['M0157'] }}</div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg pr-0 d-flex flex-column witness-col-responsive">
                      <div class="form-label">Witness Email Address<span class="text-red"></span></div>
                      <input class="form-control " [placeholder]="placeholderMessage['P0108']"
                        formControlName="witnessesEmail" />
                      <div
                        *ngIf="witnessesForm.get('witnessesEmail')?.invalid && witnessesForm.get('witnessesEmail')?.errors as errors">
                        <div
                          *ngIf="witnessesForm.get('witnessesEmail')?.invalid && witnessesForm.get('witnessesEmail')?.errors as errors">
                          <div *ngIf="errors['email'] || errors['pattern']" class="text-danger mt-1 err-font">{{
                            errorMessage['M0015'] }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg pr-0 d-flex flex-column witness-col-responsive">
                      <div class="form-label">Witness Phone Number<span class="text-red"></span></div>
                      <input class="form-control " [placeholder]="placeholderMessage['P0109']"
                        formControlName="witnessesPhone" id="witnessesPhone" aria-required="true"
                        [attr.aria-invalid]="witnessesForm.get('witnessesPhone')?.touched && witnessesForm.get('witnessesPhone')?.invalid ? 'true' : null"
                        [attr.aria-describedby]="witnessesForm.get('witnessesPhone')?.touched && witnessesForm.get('witnessesPhone')?.invalid ? 'witnessesPhone-error' : null"
                        tabindex="0" (input)="formatWitnessPhoneNumber($event)" (focus)="isPhoneFocused = true"
                        (blur)="isPhoneFocused = false; checkPhone()" numbersOnly [ngClass]="{
                  'is-invalid-error':
                    witnessesForm.get('witnessesPhone')?.touched && witnessesForm.get('witnessesPhone')?.invalid
                }" />
                      <div
                        *ngIf="witnessesForm.get('witnessesPhone')?.touched && witnessesForm.get('witnessesPhone')?.invalid && witnessesForm.get('witnessesPhone')?.errors as errors">
                        <div *ngIf="errors['M0022'] || errors['pattern']" class="text-danger mt-1 err-font">{{
                          errorMessage['M0017'] }}</div>
                        <div *ngIf="errors['maxlength']" class="text-danger mt-1 err-font">Phone number is too long.
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg pr-0 d-flex flex-column witness-col-responsive">
                      <div class="form-label">Street Address<span class="text-red"></span></div>
                      <input class="form-control " [placeholder]="placeholderMessage['P0011']"
                        formControlName="witnessesAddress" minlength="3" maxlength="60" />
                      <div
                        *ngIf="witnessesForm.get('witnessesAddress')?.invalid && witnessesForm.get('witnessesAddress')?.errors as errors">
                        <div *ngIf="errors['pattern']" class="text-danger mt-1 err-font">{{ errorMessage['M0052'] }}
                        </div>
                        <div *ngIf="errors['minlength'] || errors['maxlength']" class="text-danger mt-1 err-font">{{
                          errorMessage['M0052'] }}</div>
                        <div *ngIf="errors['M0052']" class="text-danger mt-1 err-font">{{ errorMessage['M0052'] }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex mb-3 flex-wrap witness-row-responsive">
                    <div class="col-12 col-md-6 col-lg-3 d-flex flex-column pl-1 witness-col-responsive">
                      <div class="form-label">City<span class="text-red"></span></div>
                      <input class="form-control " [placeholder]="placeholderMessage['P0013']"
                        formControlName="witnessesCity" minlength="2" maxlength="60" />
                      <div
                        *ngIf="witnessesForm.get('witnessesCity')?.invalid && witnessesForm.get('witnessesCity')?.errors as errors">
                        <div *ngIf="errors['pattern']" class="text-danger mt-1 err-font">{{ errorMessage['M0050'] }}
                        </div>
                        <div *ngIf="errors['M0050']" class="text-danger mt-1 err-font">{{ errorMessage['M0050'] }}</div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 d-flex flex-column pl-1 witness-col-responsive">
                      <div class="form-label">State</div>
                      <div class="dropdown-clear-wrapper">
                        <p-dropdown #witnessStateSelected id="witnessesState" formControlName="witnessesState"
                          [options]="stateList" styleClass="form-control" placeholder="Enter State" tabindex="0"
                          aria-required="false" 
                          [attr.aria-describedby]="witnessesForm.get('witnessesState')?.invalid ? 'witnessesState-error' : null"
                          [ngClass]="{'placeholder-color': witnessesForm.get('witnessesState')?.value === null , 
                           'selected-color' : witnessesForm.get('witnessesState')?.value !== null, 'disable-color':viewOnly}" />
                        <!-- <button *ngIf="witnessesForm.get('witnessesState')?.value" type="button" [disabled]="viewOnly"
                          id="btn_complaintForm_clear_state" class="clear-icon" tabindex="-1"
                          (click)="clearState(witnessStateSelected,false); $event.stopPropagation()"
                          aria-label="Clear selection">
                          &#10006;
                        </button> -->
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 d-flex flex-column pl-1 witness-col-responsive">
                      <div class="form-label">ZIP Code</div>
                      <div class="input-group">
                        <input class="form-control" [placeholder]="placeholderMessage['P0016']" type="text"
                          formControlName="witnessesZip" (input)="zipCodeFormat($event, 'witnessesZip')"
                          [attr.aria-invalid]="witnessesForm.get('witnessesZip')?.touched && witnessesForm.get('witnessesZip')?.invalid ? 'true' : null"
                          [attr.aria-describedby]="witnessesForm.get('witnessesZip')?.touched && witnessesForm.get('witnessesZip')?.invalid ? 'witnessesZip-error' : null"
                          [ngClass]="{'is-invalid-error': witnessesForm.get('witnessesZip')?.touched && witnessesForm.get('witnessesZip')?.invalid}" />
                      </div>
                      <div
                        *ngIf="witnessesForm.get('witnessesZip')?.invalid && witnessesForm.get('witnessesZip')?.errors as errors">
                        <div *ngIf="errors['M0023']" class="text-danger mt-1 err-font">{{ errorMessage['M0023'] }}
                        </div>
                      </div>
                      <!-- <div
                        *ngIf="witnessesForm.get('witnessesZip')?.invalid && witnessesForm.get('witnessesZip')?.errors as errors">
                        <div
                          *ngIf="witnessesForm.get('witnessesZip')?.invalid && witnessesForm.get('witnessesZip')?.errors as errors">
                          <div *ngIf="errors['M0023']" class="text-danger mt-1 err-font">{{
                            errorMessage['M0023'] }}</div>
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <div class="mt-3">
                    <p>Additional Information</p>
                  </div>
                  <div class="d-flex mt-3">
                    <div class="card w-100">
                      <p-editor *ngIf="placeholderMessage['P0110']" [class.readonly-editor]="viewOnly"
                        [placeholder]="placeholderMessage['P0110']" formControlName="witnessesTextData"
                        appWordCountLimit="10" [readonly]="viewOnly" [style]="{'height':'8rem'}" class="w-100">
                      </p-editor>
                      <div
                        *ngIf="witnessesForm.get('witnessesTextData')?.touched && witnessesForm.get('witnessesTextData')?.errors as errors">
                        <div *ngIf="errors['maxlength']" class="text-danger mt-1 err-font">Statement is too long.</div>
                      </div>
                    </div>

                  </div>
                  <div class="d-flex justify-content-end licenseactions pl-3 mt-3">
                    <button class="btn-cancel btn text-right py-1 height_btn" tooltipPosition="bottom"
                      (click)="resetData()" [disabled]="viewOnly || !formTouched">Reset</button>
                    <button type="button" class="btn btn-primary grid rounded btn-add height_btn"
                      [disabled]="viewOnly || witnessesForm.invalid" (click)="addData()" aria-label="Add" tooltipPosition="bottom">
                      <i class="pi pi-plus-circle"></i> Add</button>
                  </div>
                </div>
              </form>
              <!-- witness data grid -->
              <div class="column-chooser-actions mb-2 d-flex justify-content-end">
                <button mat-icon-button class="icon-btn" matTooltip="Column Chooser" matTooltipPosition="above"
                  matTooltipClass="custom-tooltip" (click)="showColumnChooser = !showColumnChooser"
                  id="dashboard_column_chooser_btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M4.30775 18H8.3365V6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18ZM9.8365 18H14.1635V6H9.8365V18ZM15.6635 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V6.30775C20 6.21792 19.9712 6.14417 19.9135 6.0865C19.8558 6.02883 19.7821 6 19.6923 6H15.6635V18ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775Z"
                      fill="currentColor" />
                  </svg>

                </button>
                <div *ngIf="showColumnChooser" class="column-chooser-dialog" id="dashboard_column_chooser_dialog">
                  <div class="column-chooser-header">
                    Column Chooser
                    <button class="column-chooser-close" (click)="closeColumnChooser()"
                      id="dashboard_column_chooser_close">&times;</button>
                  </div>
                  <div class="column-chooser-list">
                    <label *ngFor="let col of allColumns; let i = index" class="column-chooser-checkbox"
                      [id]="'dashboard_column_' + col.dataField">
                      <input type="checkbox"
                        (change)="onColumnVisibilityChange(col.dataField, $event.target.checked, col, i)"
                        [checked]="visibleColumns[col.dataField]" [disabled]="col.dataField === disableAppIdColumn" />
                      {{ col.label }}
                    </label>
                  </div>
                </div>
              </div>
              <app-data-grid  [config]="witnessesDataGridConfig"
                [attr.data-key]="witnessesDataGridConfig._changeKey" [actionsTemplateRef]="dashboardActionTemplate"
                id="dashboard_grid_datagrid" class="no-border-grid">
                <ng-template #dashboardActionTemplate let-row let-index="index">
                  <div class="action-buttons-container d-flex gap_action"
                    [id]="'dashboard_div_actions_' + row.application_id">
                    <div class="action-inline ml-4">
                      <div class="action-flex">
                          <button type="button" class="action-icon-button" matTooltip="Edit" matTooltipPosition="above"
                            (click)="openEditWitnessModal(row, getWitnessRowIndex(row))" [disabled]="viewOnly">
                          <svg width="24" height="24" viewBox="4 4 26 26" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M10.3077 25.501C9.80258 25.501 9.375 25.326 9.025 24.976C8.675 24.626 8.5 24.1984 8.5 23.6933V10.3087C8.5 9.80358 8.675 9.376 9.025 9.026C9.375 8.676 9.80258 8.501 10.3077 8.501H17.1598C17.4098 8.501 17.5973 8.5795 17.7223 8.7365C17.8473 8.89367 17.9098 9.06517 17.9098 9.251C17.9098 9.43683 17.8447 9.60833 17.7145 9.7655C17.5843 9.9225 17.3942 10.001 17.1442 10.001H10.3077C10.2307 10.001 10.1603 10.0331 10.0963 10.0972C10.0321 10.1612 10 10.2317 10 10.3087V23.6933C10 23.7703 10.0321 23.8407 10.0963 23.9047C10.1603 23.9689 10.2307 24.001 10.3077 24.001H23.6923C23.7692 24.001 23.8398 23.9689 23.9038 23.9047C23.9679 23.8407 24 23.7703 24 23.6933V16.7933C24 16.5433 24.0785 16.3558 24.2355 16.2308C24.3927 16.1058 24.5642 16.0433 24.75 16.0433C24.9358 16.0433 25.1073 16.1058 25.2645 16.2308C25.4215 16.3558 25.5 16.5433 25.5 16.7933V23.6933C25.5 24.1984 25.325 24.626 24.975 24.976C24.625 25.326 24.1974 25.501 23.6923 25.501H10.3077ZM14.5 18.597V16.8165C14.5 16.5753 14.5468 16.3436 14.6405 16.1212C14.734 15.8987 14.8628 15.7055 15.027 15.5415L23.5598 7.00875C23.7148 6.85358 23.8853 6.74042 24.0712 6.66925C24.2571 6.59808 24.4462 6.5625 24.6385 6.5625C24.8347 6.5625 25.0231 6.59808 25.2038 6.66925C25.3846 6.74042 25.5493 6.85033 25.698 6.999L26.9538 8.251C27.0986 8.40617 27.2098 8.57733 27.2875 8.7645C27.365 8.95167 27.4038 9.14142 27.4038 9.33375C27.4038 9.52608 27.3708 9.71258 27.3048 9.89325C27.2388 10.0741 27.1282 10.242 26.973 10.397L18.4115 18.9587C18.2473 19.1227 18.0541 19.2542 17.8318 19.353C17.6093 19.4517 17.3775 19.501 17.1365 19.501H15.404C15.1462 19.501 14.9311 19.4147 14.7588 19.2422C14.5863 19.0699 14.5 18.8548 14.5 18.597ZM16 18.001H17.2463L23.4788 11.7682L22.8558 11.1452L22.1885 10.503L16 16.6915V18.001Z"
                              fill="#444444" />
                          </svg>
                        </button>
                        <!-- Delete button only for draft applications -->
                        <button mat-icon-button class="action-icon-button ml-2" matTooltip="Delete"
                          matTooltipPosition="above" matTooltipClass="custom-tooltip"
                          (click)="deleteWitnessRow(getWitnessRowIndex(row))"
                          [id]="'dashboard_delete_row_' + row.application_id" [disabled]="viewOnly">
                          <img src="../../assets/images/neveda-images/delete-icon.svg" alt="Delete" width="24"
                            height="24" class="filter-icon">
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </app-data-grid>
              <!-- witness data grid -->
              <!-- supporting documents data grid -->
              <hr class="horizontal-line" />
              <div class="row header-row justify-content-between align-items-center mt-3 mb-3">
                <div class="w-padding">
                  <h6 class="document-grid-title">Supporting Documents</h6>
                </div>
                <div class="col-auto">
                  <div class="actions d-flex">
                    <div class="export-actions">
                    </div>
                    <div class="column-chooser-actions d-flex justify-content-end">
                              <button mat-icon-button class="icon-btn" matTooltip="Column Chooser" matTooltipPosition="above"
                                matTooltipClass="custom-tooltip"
                                (click)="showSupportingColumnChooser = !showSupportingColumnChooser"
                                id="dashboard_column_chooser_btn">
                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none">
                          <path
                            d="M4.30775 18H8.3365V6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18ZM9.8365 18H14.1635V6H9.8365V18ZM15.6635 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V6.30775C20 6.21792 19.9712 6.14417 19.9135 6.0865C19.8558 6.02883 19.7821 6 19.6923 6H15.6635V18ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775Z"
                            fill="currentColor" />
                        </svg>
                      </button>
                      <div *ngIf="showSupportingColumnChooser" class="column-chooser-dialog"
                        id="dashboard_column_chooser_dialog">
                        <div class="column-chooser-header">
                          Column Chooser
                          <button class="column-chooser-close" (click)="closeColumnChooser()"
                            id="dashboard_column_chooser_close">&times;</button>
                        </div>
                        <div class="column-chooser-list">
                          <label *ngFor="let col of allSupportingColumns; let i = index" class="column-chooser-checkbox"
                            [id]="'dashboard_column_' + col.dataField">
                            <input type="checkbox"
                              (change)="onSupportingColumnVisibilityChange(col.dataField, $event.target.checked, col, i)"
                              [checked]="visibleSupportingColumns[col.dataField]"
                              [disabled]="col.dataField === disableAppIdColumn" />
                            {{ col.label }}
                          </label>
                        </div>
                      </div>
                    </div>
                        <button type="button" class="btn btn-primary grid rounded upload-btn ml-2" aria-label="Upload"
                      pRipple icon="pi pi-plus" [pTooltip]="buttonLabel ? buttonLabel : 'Upload'"
                      tooltipPosition="bottom" (click)="showUploadModal(uploadModel)" [disabled]="viewOnly"><img class="mr-2 width-20"
                        src="../../../../assets/images/neveda-images/upload.svg" alt="" srcset="">Upload</button>
                  </div>
                </div>
              </div>
              <app-data-grid  [config]="supportingWitnessesDataGrid"
                [actionsTemplateRef]="dashboardActionTemplate1" id="dashboard_grid_datagrid">
                <ng-template #dashboardActionTemplate1 let-row let-index="index">
                  <div class="action-buttons-container d-flex gap_action">
                    <div class="action-inline ml-4">
                      <div class="action-flex">
                        <button mat-icon-button class="action-icon-button" matTooltip="Download"
                          matTooltipPosition="above" matTooltipClass="custom-tooltip"
                          (click)="downloadSupportingDocument(row)"
                          [id]="'dashboard_open_row_download_dialog_' + row.strFileName">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                            fill="none">
                            <path
                              d="M12 15.4115C11.8795 15.4115 11.7673 15.3923 11.6635 15.3538C11.5597 15.3154 11.4609 15.2494 11.3672 15.1558L8.25775 12.0463C8.10908 11.8974 8.03567 11.7233 8.0375 11.524C8.0395 11.3247 8.11292 11.1474 8.25775 10.9922C8.41292 10.8373 8.59108 10.7572 8.79225 10.752C8.99358 10.7468 9.17183 10.8218 9.327 10.977L11.25 12.9V5.25C11.25 5.03717 11.3218 4.859 11.4655 4.7155C11.609 4.57183 11.7872 4.5 12 4.5C12.2128 4.5 12.391 4.57183 12.5345 4.7155C12.6782 4.859 12.75 5.03717 12.75 5.25V12.9L14.673 10.977C14.8218 10.8283 14.9984 10.7549 15.2028 10.7568C15.4072 10.7588 15.5871 10.8373 15.7423 10.9922C15.8871 11.1474 15.9621 11.3231 15.9672 11.5192C15.9724 11.7154 15.8974 11.8911 15.7423 12.0463L12.6328 15.1558C12.5391 15.2494 12.4403 15.3154 12.3365 15.3538C12.2327 15.3923 12.1205 15.4115 12 15.4115ZM6.30775 19.5C5.80258 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V15.7308C4.5 15.5179 4.57183 15.3398 4.7155 15.1962C4.859 15.0526 5.03717 14.9808 5.25 14.9808C5.46283 14.9808 5.641 15.0526 5.7845 15.1962C5.92817 15.3398 6 15.5179 6 15.7308V17.6923C6 17.7692 6.03208 17.8398 6.09625 17.9038C6.16025 17.9679 6.23075 18 6.30775 18H17.6923C17.7692 18 17.8398 17.9679 17.9038 17.9038C17.9679 17.8398 18 17.7692 18 17.6923V15.7308C18 15.5179 18.0718 15.3398 18.2155 15.1962C18.359 15.0526 18.5372 14.9808 18.75 14.9808C18.9628 14.9808 19.141 15.0526 19.2845 15.1962C19.4282 15.3398 19.5 15.5179 19.5 15.7308V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6923 19.5H6.30775Z"
                              fill="currentColor" />
                          </svg>
                        </button>
                        <button mat-icon-button class="action-icon-button ml-2" matTooltip="Delete"
                          matTooltipPosition="above" matTooltipClass="custom-tooltip"
                          (click)="deleteSupportingDocumentRow(row)" [id]="'dashboard_delete_row_' + row.strFileName" [disabled]="viewOnly">
                          <img src="../../assets/images/neveda-images/delete-icon.svg" alt="Delete" class="filter-icon">
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </app-data-grid>
              <!-- supporting documents data grid -->
            </div>
          </div>
          <!-- witness info end-->
          <!-- decision start -->
          <div class="license-wrapper border-box">
            <div class="license-header d-flex justify-content-between align-items-center"
              (click)="decision = !decision"
              [ngClass]="{'expanded': decision, 'collapsed': !decision}">
              <h5 class=" mb-0">Complaint Decision</h5>
              <button type="button" class="toggle-btn" aria-label="Toggle" [attr.aria-expanded]="!decision"
                (click)="$event.stopPropagation(); decision = !decision">
                <span class="toggle-icon">
                  <i class="fas fa-chevron-up" *ngIf="decision" aria-hidden="true"></i>
                  <i class="fas fa-chevron-down" *ngIf="!decision" aria-hidden="true"></i>
                </span>
              </button>
            </div>
            <div *ngIf="decision" class="p-3 section-body border-box-section ">
              <div  *ngIf="!showComplaintStatus" class="d-flex justify-content-end">
                 <button type="submit" class="btn btn-primary float-md-right mb-3 rounded responsive-submit-btn"
                [disabled]="viewOnly || disabledUpdateComplaint()" (click)="onSubmit()">Update Complaint</button>
              </div>
                <div *ngIf="showComplaintStatus" class="justify-content-between d-flex responsive-complaint-decision">
                  <form [formGroup]="complaintDecisionForm" class="col-10 pl-0" novalidate>
                    <div class="row responsive-row ">
                      <div class="col-lg-4 col-md-6  pl-1 pr-0 d-flex flex-column responsive-col">
                        <div class="form-label">Complaint Status</div>
                        <div class="dropdown-clear-wrapper">
                          <p-dropdown #complaintStatusDropdown id="select_complainant_status"
                            formControlName="complaintStatus" [options]="complaintStatusMessages" 
                            optionLabel="value" optionValue="key" [autoDisplayFirst]="false"
                            styleClass="custom-dropdown-border form-control" [placeholder]="placeholderMessage['P0128']"
                             aria-required="false"
                            tabindex="0" 
                             [attr.aria-describedby]="complaintDecisionForm.get('complaintStatus')?.invalid ? 'complaintStatus-error' : null"
                          [ngClass]="{'placeholder-color': complaintDecisionForm.get('complaintStatus')?.value === null  ,
                           'selected-color' :  complaintDecisionForm.get('complaintStatus')?.value !== null,
                        'disable-color':viewOnly}" />
                          <!-- <button *ngIf="complaintDecisionForm.get('complaintStatus')?.value" type="button"
                            id="btn_complaintDecisionForm_clear_status" class="clear-icon" tabindex="-1" [disabled]="viewOnly"
                            (click)="clearComplaintStatus(); $event.stopPropagation()" aria-label="Clear selection">
                            &#10006;
                          </button> -->
                        </div>
                         <div *ngIf="complaintDecisionForm.get('complaintStatus')?.invalid && (complaintDecisionForm.get('complaintStatus')?.touched || complaintDecisionForm.get('complaintStatus')?.dirty)"
                          class="text-danger mt-1 err-font">{{ errorMessage['M0162'] }}</div>
                      </div>
                      <div *ngIf="showAssignedToField" class="col-lg-4 col-md-6 d-flex flex-column witness-col-responsive">
                      <div class="form-label">Assign To</div>
                      <div class="dropdown-clear-wrapper">
                        <p-dropdown #complaintAssign id="witnessesState" formControlName="complaintAssign"
                          [options]="assignToList" optionLabel="full_name" optionValue="id"
                          styleClass="form-control" [placeholder]="placeholderMessage['P0063']" tabindex="0"
                          aria-required="false" [autoDisplayFirst]="false" 
                          [attr.aria-describedby]="complaintDecisionForm.get('complaintAssign')?.invalid ? 'complaintAssign-error' : null"
                          [ngClass]="{'placeholder-color':complaintDecisionForm.get('complaintAssign')?.value === null , 
                          'selected-color' : complaintDecisionForm.get('complaintAssign')?.value !== null,
                        'disable-color':viewOnly}" />
                        <!-- <button *ngIf="complaintDecisionForm.get('complaintAssign')?.value" type="button"
                          id="btn_complaintDecisionForm_clear_assign" class="clear-icon" tabindex="-1" [disabled]="viewOnly"
                          (click)="clearAssignedTo(); $event.stopPropagation()"
                          aria-label="Clear selection">
                          &#10006;
                        </button> -->
                      </div>
                    </div>
                    </div>
                  </form>
                  <button type="button" class="btn btn-primary float-md-right mb-4 mt-2 rounded responsive-submit-btn"
                    [disabled]="disabledComplaintStatus() || viewOnly" (click)="updateComplaintStatus()">Update Status</button>
                </div>
            </div>
          </div>
          <!-- decision end-->
           <!-- Archival start -->
          <div *ngIf="showComplaintStatus" class="license-wrapper border-box" >
            <div class="license-header d-flex justify-content-between align-items-center"
              (click)="archival = !archival"
              [ngClass]="{'expanded': archival, 'collapsed': !archival}">
              <h5 class=" mb-0">Complaint Archival</h5>
              <button type="button" class="toggle-btn" aria-label="Toggle" [attr.aria-expanded]="!archival"
                (click)="$event.stopPropagation(); archival = !archival">
                <span class="toggle-icon">
                  <i class="fas fa-chevron-up" *ngIf="archival" aria-hidden="true"></i>
                  <i class="fas fa-chevron-down" *ngIf="!archival" aria-hidden="true"></i>
                </span>
              </button>
            </div>
            <div *ngIf="archival" class="p-3 section-body border-box-section ">
                <div class="justify-content-between d-flex responsive-archival">
                  <form [formGroup]="complaintArchivalForm" class="col-10 pl-0" novalidate>
                    <div class="row responsive-row ">
                      <div class="col-lg-4 col-md-6  pl-1 pr-0 d-flex flex-column responsive-col">
                        <div class="form-label">Archival Status</div>
                        <div class="dropdown-clear-wrapper">
                          <p-dropdown #complaintArchivalStatus id="select_complainant_status"
                            formControlName="complaintArchivalStatus" [options]="complaintArchivalStatusMessages" 
                            optionLabel="value" optionValue="key" [autoDisplayFirst]="false"
                            styleClass="custom-dropdown-border form-control" [placeholder]="placeholderMessage['P0129']"
                             aria-required="false" 
                            tabindex="0" [attr.aria-describedby]="complaintArchivalForm.get('complaintArchivalStatus')?.invalid ? 'complaintArchivalStatus-error' : null"
                          [ngClass]="{'placeholder-color':complaintArchivalForm.get('complaintArchivalStatus')?.value === null , 
                          'selected-color': complaintArchivalForm.get('complaintArchivalStatus')?.value !== null,
                        'disable-color':viewOnly}" />
                          <!-- <button *ngIf="complaintArchivalForm.get('complaintArchivalStatus')?.value" type="button" 
                            id="btn_complaintArchivalForm_clear_status" class="clear-icon" tabindex="-1" [disabled]="viewOnly"
                            (click)="clearComplaintArchivalStatus(); $event.stopPropagation()" aria-label="Clear selection">
                            &#10006;
                          </button> -->
                        </div>
                        <div *ngIf="complaintArchivalForm.get('complaintArchivalStatus')?.invalid && (complaintArchivalForm.get('complaintArchivalStatus')?.touched || complaintArchivalForm.get('complaintArchivalStatus')?.dirty)"
                          class="text-danger mt-1 err-font">{{ errorMessage['M0165'] }}</div>
                      </div>
                    </div>
                  </form>
                  <button type="submit" class="btn btn-primary float-md-right mb-4 mt-2 rounded responsive-submit-btn"
                    [disabled]="viewOnly || complaintArchivalForm.invalid" (click)="updateComplaintArchivalStatus()">Update Status</button>
                </div>
            </div>
          </div>
          <!-- decision end-->
           <!-- Notes start -->
          <div *ngIf="showComplaintStatus" class="license-wrapper border-box" >
            <div class="license-header d-flex justify-content-between align-items-center"
              (click)="Notes = !Notes"
              [ngClass]="{'expanded': Notes, 'collapsed': !Notes}">
              <h5 class=" mb-0">Internal Notes</h5>
              <button type="button" class="toggle-btn" aria-label="Toggle" [attr.aria-expanded]="!Notes"
                (click)="$event.stopPropagation(); Notes = !Notes">
                <span class="toggle-icon">
                  <i class="fas fa-chevron-up" *ngIf="Notes" aria-hidden="true"></i>
                  <i class="fas fa-chevron-down" *ngIf="!Notes" aria-hidden="true"></i>
                </span>
              </button>
            </div>
            <div *ngIf="Notes" class="p-3 section-body border-box-section ">
                <div class="mb-3">
                  <form [formGroup]="complaintNotesForm" class="pl-0" novalidate>
                    <div class="row responsive-row ">
                      <div class="col-lg-6 col-md-6  pl-1 pr-0 d-flex flex-column responsive-col">
                        <div class="form-label">Section</div>
                        <div class="dropdown-clear-wrapper">
                          <p-dropdown #complaintNotesSection id="select_complaint_notes_section"
                            formControlName="complaintNotesSection" [options]="complaintNotesSectionList" 
                           [autoDisplayFirst]="false" [placeholder]="placeholderMessage['P0099']"
                            styleClass="custom-dropdown-border form-control"
                             aria-required="false" 
                            tabindex="0" [attr.aria-describedby]="complaintNotesForm.get('complaintNotesSection')?.invalid ? 'complaintNotesSection-error' : null"
                          [ngClass]="{'placeholder-color':complaintNotesForm.get('complaintNotesSection')?.value === null ,
                           'selected-color':complaintNotesForm.get('complaintNotesSection')?.value !== null,
                           'disable-color':viewOnly}" />
                          <!-- <button *ngIf="complaintNotesForm.get('complaintNotesSection')?.value" type="button"
                            id="btn_complaintNotesForm_clear_section" class="clear-icon" tabindex="-1" [disabled]="viewOnly"
                            (click)="clearComplaintNotesSection(); $event.stopPropagation()" aria-label="Clear selection">
                            &#10006;
                          </button> -->
                        </div>
                        <div *ngIf="complaintNotesForm.get('complaintNotesSection')?.invalid && (complaintNotesForm.get('complaintNotesSection')?.touched || complaintNotesForm.get('complaintNotesSection')?.dirty)"
                          class="text-danger mt-1 err-font">{{ errorMessage['M0136'] }}</div>
                      </div>
                      </div>
                      <div class="form-group position-relative mt-3">
                          <label for="input_fingerprint_form_note">Notes</label>
                          <textarea type="text" id="input_fingerprint_form_note" formControlName="complaintNotesTextData"
                              class="form-control" rows="3" placeholder="{{placeholderMessage['P0089']}}" maxlength="4000"></textarea>
                          <div *ngIf="complaintNotesForm.get('complaintNotesTextData')?.invalid && (complaintNotesForm.get('complaintNotesTextData')?.touched || complaintNotesForm.get('complaintNotesTextData')?.dirty)"
                          class="text-danger mt-1 err-font">{{ errorMessage['M0126'] }}</div>
                      </div>
                      <div class="d-flex justify-content-end licenseactions pl-3 mt-3">
                        <button class="btn-cancel btn text-right py-1 height_btn" tooltipPosition="bottom"
                          (click)="resetNotesData()" [disabled]="viewOnly || !notesFormTouched">Reset</button>
                        <button type="button" class="btn btn-primary grid rounded btn-add height_btn"
                          [disabled]="viewOnly || complaintNotesForm.invalid" (click)="addNotesData()" aria-label="Add" tooltipPosition="bottom">
                          <i class="pi pi-plus-circle"></i> Add</button>
                      </div>
                  </form>
                </div>
                <app-data-grid id="complaintNotesGrid" [config]="complaintNotesGridConfig"
                  [actionsTemplateRef]="complaintNotesActionsTemplate" [activeTab]="'background'">
                <ng-template #complaintNotesActionsTemplate let-row let-index="index">
                  <div class="action-buttons-container"
                    [id]="'dashboard_div_actions_' + row.index">
                    <span class="action-span-wrapper">
                        <button mat-icon-button class="action-icon-button ml-2" matTooltip="Edit"
                          matTooltipPosition="above" matTooltipClass="custom-tooltip"
                          (click)="notesModal(row,true,false)" [disabled]="viewOnly"
                          [id]="'complaint_notes_edit_row_' + row.index">
                          <img src="../../assets/images/neveda-images/edit-icon.svg" alt="Edit" width="24"
                            height="24" class="filter-icon">
                        </button>
                    </span>
                    <span class="action-span-wrapper">
                        <button mat-icon-button class="action-icon-button ml-2" matTooltip="View"
                          matTooltipPosition="above" matTooltipClass="custom-tooltip"
                          (click)="notesModal(row,false,true)"
                          [id]="'complaint_notes_view_row_' + row.index">
                          <img src="../../assets/images/neveda-images/eye.svg" alt="View" width="24"
                            height="24" class="filter-icon">
                        </button>
                    </span>
                    <span class="action-span-wrapper">
                        <button  mat-icon-button class="action-icon-button ml-2" matTooltip="Delete"
                          matTooltipPosition="above" matTooltipClass="custom-tooltip" [disabled]="viewOnly" 
                          (click)="deleteNotesRow(row)"
                          [id]="'complaint_notes_delete_row_' + row.index">
                          <img src="../../assets/images/neveda-images/delete-icon.svg" alt="Delete" width="24"
                            height="24" class="filter-icon">
                        </button>
                    </span>
                  </div>
                </ng-template>
              </app-data-grid>
            </div>
          </div>
          <!-- Notes end-->
        </form>
      </div>
      <hr class="mb-2" />
      <div class="mb-5">
        <button class="btn btn-primary float-right " (click)="moveToNext()">
          <span class="fas fa-arrow-right"></span> Next
        </button>
      </div>
    </div>

<!-- Delete Modal -->
<div *ngIf="showDeleteModal" class="delete-modal" id="dashboard_delete_modal">
  <div class="modal-content">
    <div class="modal-header">      
      <h6 class="w-100 text-start font-weight-bold mb-0">Delete Record</h6>
      <img src="assets/images/neveda-images/close.svg" id="close_img" alt="close_icon" (click)="closeDeleteModal()" class="pt-1">
    </div>
    <div class="modal-body">
      <div class="modal-content-wrapper">
        <div class="template-content">Are you sure you want to delete this record? This action cannot be undone.</div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="flex-fill">
        <button class="btn w-50 btn-outline" (click)="closeDeleteModal()">Cancel</button>
        <button class="btn w-50 btn-danger btn-radius" (click)="confirmDeleteWitnessRow()">Delete</button>
      </div>
    </div>
  </div>
</div>

<!-- Delete Notes Modal -->
<div *ngIf="showDeleteNotesModal" class="delete-modal" id="dashboard_delete_modal">
  <div class="modal-content">
    <div class="modal-header">      
      <h6 class="w-100 text-start font-weight-bold mb-0">Delete Note</h6>
      <img src="assets/images/neveda-images/close.svg" id="close_img" alt="close_icon" (click)="closeDeleteModal()" class="pt-1">
    </div>
    <div class="modal-body">
      <div class="modal-content-wrapper">
        <div class="template-content">Are you sure you want to delete this note? This action cannot be undone.</div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="flex-fill">
        <button class="btn w-50 btn-outline" (click)="closeDeleteModal()">Cancel</button>
        <button class="btn w-50 btn-danger btn-radius" (click)="confirmDeleteWitnessRow()">Delete</button>
      </div>
    </div>
  </div>
</div>
<!-- witness Edit Form (show only when editing) -->
<ng-template #editWitnessModal let-modal>
  <div class="custom-ngb-modal">
    <form [formGroup]="editWitnessesForm">
      <div class="modal-header">
        <h4 class="modal-title">Edit Record</h4>
        <button type="button" class="close activities-modal-dismiss" aria-labelledby="lookup-edit-prior-title" (click)="closeModal()" (keypress)="closeModal()" aria-label="Close" tabindex="0">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="exam-edit-form-wrapper mb-3">
          <div class="mb-4">
            <div class="row mb-3 mr-2">
              <div class="col pr-0 d-flex flex-column">
                <div class="form-label">Witness Name<span class="text-red">*</span></div>
                <input class="form-control " [placeholder]="placeholderMessage['P0107']" formControlName="witnesseName"
                  type="text" tabindex="0" id="editModalWitnessesName" maxlength="30" minlength="2" required
                  aria-label="Enter Witness Name" aria-required="true"
                  [attr.aria-invalid]="editWitnessesForm.get('witnesseName')?.touched && editWitnessesForm.get('witnesseName')?.invalid ? 'true' : null"
                  [attr.aria-describedby]="editWitnessesForm.get('witnesseName')?.touched && editWitnessesForm.get('witnesseName')?.invalid ? 'witnessesName-error' : null"
                  (input)="witnessesName($event, 'modal')" (blur)="checkForTrailingSpace($event, 'witnesseName')"
                  [ngClass]="{'is-invalid-error': editWitnessesForm.get('witnesseName')?.touched && editWitnessesForm.get('witnesseName')?.invalid}" />
                <div
                  *ngIf="editWitnessesForm.get('witnesseName')?.invalid && (editWitnessesForm.get('witnesseName')?.touched || editWitnessesForm.get('witnesseName')?.dirty)"
                  class="text-danger small">
                  <div *ngIf="editWitnessesForm.get('witnesseName')?.errors?.required"
                    class="text-danger mt-1 err-font">{{ errorMessage['M0140'] }}</div>
                  <div
                    *ngIf="!editWitnessesForm.get('witnesseName')?.errors?.required && (editWitnessesForm.get('witnesseName')?.errors?.pattern || editWitnessesForm.get('witnesseName')?.errors?.minlength || editWitnessesForm.get('witnesseName')?.errors?.maxlength)"
                    class="text-danger mt-1 err-font">{{ errorMessage['M0157'] }}</div>
                </div>
              </div>
              <div class="col pr-0 d-flex flex-column">
                <div class="form-label">Witness Email Address<span class="text-red"></span></div>
                <input class="form-control " [placeholder]="placeholderMessage['P0108']"
                  formControlName="witnessesEmail" />
                <div
                  *ngIf="editWitnessesForm.get('witnessesEmail')?.touched && editWitnessesForm.get('witnessesEmail')?.errors as errors">
                  <div *ngIf="errors['email']" class="text-danger mt-1 err-font">{{ errorMessage['M0015'] }}</div>
                  <div *ngIf="errors['pattern']" class="text-danger mt-1 err-font">{{ errorMessage['M0015'] }}</div>
                </div>
              </div>
              <div class="col pr-0 d-flex flex-column">
                <div class="form-label">Witness Phone Number<span class="text-red"></span></div>
                <input class="form-control " [placeholder]="placeholderMessage['P0109']"
                  formControlName="witnessesPhone" id="witnessesPhone" aria-required="true"
                  [attr.aria-invalid]=" editWitnessesForm.get('witnessesPhone')?.invalid || phoneExists ? 'true' : null"
                  [attr.aria-describedby]=" editWitnessesForm.get('witnessesPhone')?.invalid || phoneExists ? 'witnessesPhone-error' : null"
                  tabindex="0" (input)="formatEditWitnessPhoneNumber($event)" (focus)="isPhoneFocused = true"
                  (blur)="isPhoneFocused = false; checkPhone()" numbersOnly [ngClass]="{
                  'is-invalid-error':
                    editWitnessesForm.get('witnessesPhone')?.invalid || (phoneExists && !isPhoneFocused)
                }" />
                <div
                  *ngIf="editWitnessesForm.get('witnessesPhone')?.invalid && editWitnessesForm.get('witnessesPhone')?.errors as errors">
                  <div *ngIf="errors['pattern']" class="text-danger mt-1 err-font">{{ errorMessage['M0017'] }}</div>
                </div>
              </div>
              <div class="col pr-0 d-flex flex-column">
                <div class="form-label">Street Address<span class="text-red"></span></div>
                <input class="form-control " [placeholder]="placeholderMessage['P0011']"
                  formControlName="witnessesAddress" minlength="3" maxlength="60" />
                <div
                  *ngIf="editWitnessesForm.get('witnessesAddress')?.touched && editWitnessesForm.get('witnessesAddress')?.errors as errors">
                  <div *ngIf="errors['pattern'] || errors['minlength'] || errors['maxlength']"
                    class="text-danger mt-1 err-font">Please enter a valid address.</div>
                </div>
              </div>
            </div>
            <div class="d-flex mb-3">
              <div class="col-lg-3 col-md-3 col-sm-3 d-flex flex-column pl-1">
                <div class="form-label">City<span class="text-red"></span></div>
                <input class="form-control " [placeholder]="placeholderMessage['P0013']" formControlName="witnessesCity"
                  minlength="2" maxlength="60" />
                <div
                  *ngIf="editWitnessesForm.get('witnessesCity')?.invalid && editWitnessesForm.get('witnessesCity')?.errors as errors">
                  <div *ngIf="errors['pattern']" class="text-danger mt-1 err-font">{{ errorMessage['M0050'] }}
                  </div>
                  <div *ngIf="errors['M0050']" class="text-danger mt-1 err-font">{{ errorMessage['M0050'] }}</div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-3 d-flex flex-column pl-1 witness-col-responsive">
                      <div class="form-label">State</div>
                      <div class="dropdown-clear-wrapper">
                        <p-dropdown #editwitnessStateSelected id="witnessesState" formControlName="witnessesState"
                          [options]="stateList" styleClass="form-control" placeholder="Enter State" tabindex="0"
                          aria-required="false" 
                          [attr.aria-describedby]="editWitnessesForm.get('witnessesState')?.invalid ? 'witnessesState-error' : null"
                          [ngClass]="{'placeholder-color' : editWitnessesForm.get('witnessesState')?.value === null , 
                           'selected-color' : editWitnessesForm.get('witnessesState')?.value !== null,
                          'disable-color':viewOnly}" />
                        <!-- <button *ngIf="editWitnessesForm.get('witnessesState')?.value" type="button"
                          id="btn_complaintForm_clear_state" class="clear-icon" tabindex="-1"
                          (click)="clearState(editwitnessStateSelected,false,true); $event.stopPropagation()"
                          aria-label="Clear selection">
                          &#10006;
                        </button> -->
                      </div>
                    </div>
              <div class=" col-lg-3 col-md-3 col-sm-3 d-flex flex-column pl-1">
                <div class="form-label">ZIP Code</div>
                <div class="input-group">
                  <input class="form-control" (input)="zipCodeFormat($event, 'witnesseZip')"
                    [placeholder]="placeholderMessage['P0016']" type="text" formControlName="witnesseZip" />
                </div>
                <div
                  *ngIf="editWitnessesForm.get('witnesseZip')?.invalid && editWitnessesForm.get('witnesseZip')?.errors as errors">
                  <div *ngIf="errors['M0023']" class="text-danger mt-1 err-font">{{ errorMessage['M0023'] }}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="modal-footer border-top d-flex gap-2">
        <button type="button" class="btn-cancel btn btn-primary btn-lg py-2 px-4 brdrradius"
          (click)="onEditWitnessesReset(selectedRow)">Reset</button>
        <button type="button" class="btn btn-primary btn-lg btnprimary"
          [disabled]="editWitnessesForm.invalid || editWitnessesForm.pristine || !isChanged"
          (click)="updatewitness()">Update</button>
      </div>
    </form>
  </div>
</ng-template>

<!-- upload Modal -->
<ng-template #uploadModel let-modal>
  <form #uploadForm="ngForm" novalidate>
    <div class="upload-form-popup">
      <div class="form-modal-header p-4 d-flex justify-content-between">
        <h4 class="modal-title">Upload Files</h4>
        <button type="button" class="close" aria-label="Close" (click)="closeUploadPopup()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-modal-body pl-4 pr-4 pt-4 pb-2">
        <div class="mb-3">
          <!-- <label class="col-form-label mb-2">Select File <span class="text-danger">*</span></label> -->
          <div class="upload-drop-area" (click)="fileInputRef.click()" (dragover)="$event.preventDefault()"
            (dragleave)="$event.preventDefault()" (drop)="onDropFile($event)">
            <div class="upload-drop-content">
              <span class="p-button-icon p-button-icon-left pi pi-upload upload"></span>
              <span>Drag &amp; drop or <span class="choose-file-link">choose file</span> to upload</span>
            </div>
            <input type="file" #fileInputRef class="file-input-hidden" (change)="handleFileUpload($event)"
              accept=".pdf,.jpg,.jpeg,.png,.mp4,.mp3" />
          </div>
          <div class="no-file-uploaded mt-20" [ngClass]="!uploadData.file?'no-file-uploaded border-0':''"><i
              *ngIf="!uploadData.file" class="pi pi-file"></i>
            <span *ngIf="uploadData.file" class="text-left border-0">{{ uploadData.file.name }}</span>
            <span *ngIf="!uploadData.file">No file
              uploaded</span>
          </div>
          <div *ngIf="uploadError" class="text-danger small mt-2">{{ uploadError }}</div>
        </div>
        <div class="mb-3 filedetails">
          <p class="filesformat">
            Supported formats: PDF, JPG, JPEG, PNG, MP4, MP3.
          </p>
          <p class="filesformat">
            Maximum size: 15 MB.
          </p>
        </div>
      </div>
      <div class="form-modal-footer p-3 d-flex">
        <button type="button" class="btn-cancel btn  btn-md  px-3 py-1" (click)="closeUploadPopup()">Cancel</button>
        <button lang="en" class="btn btn-primary btn-md rounded ms-2" type="button" name="data[submit]"
          [disabled]="viewOnly || saveEnable" (click)="onSave()" ref="button">Save</button>
      </div>
    </div>

  </form>
</ng-template>
<!-- licenseEducator Details-->
<ng-template #addLicenseEducator let-modal>
  <div class="custom-ngb-modal">
    <form [formGroup]="licenseEducatorForm">
      <div class="modal-header d-flex justify-content-between align-items-center">
        <h4 class="fw-bold m-0">Search Licensed Educator</h4>
        <div class="btn-modal-close cursor-pointer">
          <img src="assets/images/neveda-images/close.svg" id="close_img" (click)="closeLicenseModal()"
            (keypress)="closeLicenseModal()" alt="close_icon" tabindex="0">
        </div>
      </div>
      <div class="modal-body mb-3 pb-0">
        <div class="exam-edit-form-wrapper mb-3">
            <div class="row mb-4 mr-2">
              <div class="col-12 col-md-4 mb-2">
                <div class="form-label mb-1">Educator Name</div>
                <input class="form-control " [placeholder]="placeholderMessage['P0105']" formControlName="educator_name"
                  type="text" tabindex="0" id="licenseEducatorName" maxlength="30" minlength="2" 
                  aria-label="Enter Educator Name"/>
              </div>
              <div class="col-12 col-md-4 mb-2">
                <div class="form-label mb-1">Email</div>
                <input class="form-control " [placeholder]="placeholderMessage['P0009']"
                  formControlName="primary_email" />
              </div>
              <div class="col-12 col-md-4 mb-2">
                <div class="form-label mb-1">License Number</div>
                <input class="form-control " [placeholder]="placeholderMessage['P0118']"
                  formControlName="license_number" id="licenseNumber"
                   numbersOnly />
              </div>
            </div>
            <div class=" d-flex w-100 justify-content-end mb-10">
              <button type="button" class="btn btn-outline btn-modal-action me-3 btn-radius"
                [disabled]="viewOnly || isSearchDisabled()"
                (click)="onLicenseEducator()">Reset</button>
              <button type="button" class="btn btn-primary btn-modal-action btn-radius"
                [disabled]="viewOnly || isSearchDisabled()"
                (click)="searchLicenseEducator()">Search</button>
            </div>
        </div>
      </div>
    </form>
    <div class="modal-footer mt-2 p-3">
      <div class="col-auto">
        <div class="actions d-flex">
          <div class="action-span-wrapper mr-3">
                <button type="button" class="icon-btn" matTooltip="Refresh" matTooltipPosition="above"
                matTooltipClass="custom-tooltip" [disabled]="viewOnly"
                  (click)="$event.stopPropagation(); onRefresh()">
                  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="39" height="39" rx="3.5" fill="white"/>
                    <rect x="0.5" y="0.5" width="39" height="39" rx="3.5" stroke="#E2E3E6"/>
                    <path d="M13.75 20.0505C13.75 20.3428 13.7698 20.6342 13.8095 20.9245C13.8493 21.215 13.9173 21.5013 14.0135 21.7833C14.0775 21.9961 14.0707 22.1996 13.9932 22.3938C13.9157 22.5879 13.784 22.7273 13.598 22.812C13.4018 22.9068 13.2067 22.9145 13.0125 22.835C12.8183 22.7555 12.6892 22.6094 12.625 22.3968C12.4917 22.0198 12.3958 21.6328 12.3375 21.236C12.2792 20.8393 12.25 20.4442 12.25 20.0505C12.25 17.8877 13.0026 16.047 14.5078 14.5285C16.0129 13.0098 17.8437 12.2505 20 12.2505H20.7808L19.4577 10.9275C19.3193 10.789 19.2484 10.6149 19.2453 10.4053C19.2421 10.1958 19.3129 10.0185 19.4577 9.8735C19.6026 9.72867 19.7782 9.65625 19.9845 9.65625C20.191 9.65625 20.3667 9.72867 20.5115 9.8735L23.0057 12.3678C23.1866 12.5486 23.277 12.7595 23.277 13.0005C23.277 13.2415 23.1866 13.4524 23.0057 13.6333L20.5115 16.1275C20.373 16.2658 20.199 16.3367 19.9895 16.34C19.7798 16.3432 19.6026 16.2723 19.4577 16.1275C19.3129 15.9825 19.2405 15.8068 19.2405 15.6005C19.2405 15.3942 19.3129 15.2185 19.4577 15.0735L20.7808 13.7505H20C18.2628 13.7505 16.7868 14.362 15.572 15.585C14.3573 16.8082 13.75 18.2967 13.75 20.0505ZM26.25 19.9505C26.25 19.6582 26.2302 19.3668 26.1905 19.0765C26.1507 18.786 26.0827 18.4998 25.9865 18.2178C25.9225 18.0049 25.9293 17.8014 26.0068 17.6073C26.0843 17.4131 26.216 17.2737 26.402 17.189C26.5982 17.0942 26.7917 17.0865 26.9827 17.166C27.1737 17.2455 27.3012 17.3916 27.3652 17.6043C27.4986 17.9813 27.5961 18.3682 27.6578 18.765C27.7192 19.1617 27.75 19.5568 27.75 19.9505C27.75 22.1133 26.9974 23.954 25.4923 25.4725C23.9871 26.9912 22.1563 27.7505 20 27.7505H19.2192L20.5423 29.0735C20.6807 29.212 20.7516 29.3861 20.7548 29.5958C20.7579 29.8053 20.6871 29.9825 20.5423 30.1275C20.3974 30.2723 20.2218 30.3448 20.0155 30.3448C19.809 30.3448 19.6333 30.2723 19.4885 30.1275L16.9942 27.6333C16.8134 27.4524 16.723 27.2415 16.723 27.0005C16.723 26.7595 16.8134 26.5486 16.9942 26.3678L19.4885 23.8735C19.627 23.7352 19.801 23.6643 20.0105 23.661C20.2202 23.6578 20.3974 23.7287 20.5423 23.8735C20.6871 24.0185 20.7595 24.1942 20.7595 24.4005C20.7595 24.6068 20.6871 24.7825 20.5423 24.9275L19.2192 26.2505H20C21.7372 26.2505 23.2132 25.639 24.428 24.416C25.6427 23.1928 26.25 21.7043 26.25 19.9505Z" fill="#444444"/>
                  </svg>
              </button>
            </div>
          <div class="column-chooser-actions d-flex justify-content-end ">
            <button mat-icon-button class="icon-btn" matTooltip="Column Chooser" matTooltipPosition="above"
              matTooltipClass="custom-tooltip"
              (click)="showSearchLicenseEducatorColumnChooser = !showSearchLicenseEducatorColumnChooser"
              id="dashboard_column_chooser_btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none">
                <path
                  d="M4.30775 18H8.3365V6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18ZM9.8365 18H14.1635V6H9.8365V18ZM15.6635 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V6.30775C20 6.21792 19.9712 6.14417 19.9135 6.0865C19.8558 6.02883 19.7821 6 19.6923 6H15.6635V18ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775Z"
                  fill="currentColor" />
              </svg>
            </button>
            <div *ngIf="showSearchLicenseEducatorColumnChooser" class="column-chooser-dialog-search-licensed"
              id="dashboard_column_chooser_dialog">
              <div class="column-chooser-header">
                Column Chooser
                <button class="column-chooser-close" (click)="closeSearchLicenseEducatorColumnChooser()"
                  id="dashboard_column_chooser_close">&times;</button>
              </div>
              <div class="column-chooser-list">
                <label *ngFor="let col of licenseEducatorColumns; let i = index" class="column-chooser-checkbox"
                  [id]="'dashboard_column_' + col.dataField">
                  <input type="checkbox"
                    (change)="onSearchLicenseEducatorColumnVisibilityChange(col.dataField, $event.target.checked, col, i)"
                    [checked]="visibleSearchLicenseEducatorColumns[col.dataField]" />
                  {{ col.label }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid-component">
       <app-data-grid id="licenseEducatorGrid" [config]="searchLicenseEducatorDataGridConfig"
       [onEducatorNameClick]="onEducatorNameClick"
        [actionsTemplateRef]="searchLicenseEducatorActionsTemplate"  [activeTab]="'background'">
          <ng-template #searchLicenseEducatorActionsTemplate let-row let-index="index">
            <div class="action-buttons-container d-flex gap_action"
              [id]="'dashboard_div_actions_' + row.index">
              <div class="action-inline ml-4">
                <div class="action-flex">
                  <!-- Delete button only for draft applications -->
                  <button mat-icon-button class="action-icon-button ml-2" matTooltip="Link to Case"
                    matTooltipPosition="above" matTooltipClass="custom-tooltip"
                    (click)="linkToCase(row)"
                    [id]="'license_educator_delete_row_' + row.index">
                    <img src="../../assets/images/neveda-images/link-to-case.svg" alt="Delete" width="24"
                      height="24" class="filter-icon">
                  </button>
                </div>
              </div>
            </div>
          </ng-template>
        </app-data-grid>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #NotesModal let-modal>
  <div class="custom-ngb-modal">
    <form [formGroup]="editComplaintNotesForm" class="pl-0" novalidate>
      <div class="modal-header">
        <h4 *ngIf="isViewNotes" class="modal-title">View Note</h4>
        <h4 *ngIf="isEditNotes" class="modal-title">Edit Note</h4>
        <div class="btn-modal-close cursor-pointer">
          <img src="assets/images/neveda-images/close.svg" id="close_img" (click)="closeViewNotesModal()"
            (keypress)="closeViewNotesModal()" alt="close_icon" tabindex="0">
        </div>
      </div>
      <div class="modal-body mb-3 pb-0">
      <div class="row responsive-row ">
        <div class="col-lg-10 col-md-10 pl-1 pr-0 d-flex flex-column responsive-col">
          <div class="form-label">Section</div>
          <div class="dropdown-clear-wrapper">
            <p-dropdown #complaintNotesSection id="select_complaint_notes_section"
              formControlName="editNotesSection" [options]="complaintNotesSectionList"
              [autoDisplayFirst]="false" [placeholder]="placeholderMessage['P0089']"
              styleClass="custom-dropdown-border form-control"
                aria-required="false"
              tabindex="0" [attr.aria-describedby]="editComplaintNotesForm.get('editNotesSection')?.invalid ? 'editNotesSection-error' : null"
              [disabled]="isViewNotes"
              [ngClass]="{
                'placeholder-color': editComplaintNotesForm.get('editNotesSection')?.value === null,
                'selected-color': editComplaintNotesForm.get('editNotesSection')?.value !== null,
                'disable-color': isViewNotes
              }" />
            <!-- <button *ngIf="editComplaintNotesForm.get('editNotesSection')?.value" type="button"
              id="btn_editComplaintNotesForm_clear_section" class="clear-icon" tabindex="-1" [disabled]="isViewNotes"
              (click)="clearEditComplaintNotesSection(); $event.stopPropagation()" aria-label="Clear selection">
              &#10006;
            </button> -->
          </div>
        </div>
        </div>
        <div class="form-group position-relative mt-3">
            <label for="input_fingerprint_form_note">Notes</label>
            <textarea type="text" id="input_fingerprint_form_note" formControlName="editNotesTextData"
              class="form-control" rows="3" placeholder="{{placeholderMessage['P0089']}}" maxlength="4000"
              [disabled]="isViewNotes"></textarea>
        </div>
      </div>
      <div class="modal-footer border-top d-flex gap-2">
          <div *ngIf="isEditNotes">
            <button class="btn-cancel btn btn-primary btn-lg py-2 px-4 brdrradius" [disabled]="viewOnly"
              (click)="resetEditModal()">Reset</button>
            <button type="button" class="btn btn-primary btn-lg btnprimary"
              [disabled]="viewOnly || editComplaintNotesForm.invalid" (click)="updateNotesData()" aria-label="Update"
              tooltipPosition="bottom">
              Update</button>
          </div>
          <div *ngIf="isViewNotes">
            <button class="btn-cancel btn btn-primary btn-lg py-2 px-4 brdrradius" tooltipPosition="bottom"
              (click)="closeViewNotesModal()">Close</button>
          </div>
        </div>
    </form>
  </div>
</ng-template>